var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWarning = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0C5.036 0 0 5.037 0 11.25 0 17.464 5.036 22.5 11.25 22.5c6.213 0 11.25-5.036 11.25-11.25C22.5 5.037 17.463 0 11.25 0zM9.83 5.795a1.421 1.421 0 012.84 0v6.327a1.421 1.421 0 01-2.84 0V5.795zm1.42 12.33c-.893 0-1.62-.727-1.62-1.62 0-.894.726-1.621 1.62-1.621.894 0 1.62.726 1.62 1.62 0 .894-.726 1.621-1.62 1.621z",
    fill: "#3e704b",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.7acd4a92.svg";
export { ForwardRef as ReactComponent };